import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class ChangerequestService  extends Subject<DataStateChangeEventArgs>  {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) { 
    super();
    this.httpClient = new HttpClient(handler);
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
     
}

  // Create changeRequests
  createChangeRequests(user: Object): Observable<Object> {
    console.log("In createChangeRequests method, ChangeRequests: ", user);
    return this.http.post(`${environment.apiUrl}/changeRequests`, user).pipe(catchError(this.handleError));
  }

   // Get changeRequests by Id Get
   getChangeRequests(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/changeRequests/${id}`).pipe(catchError(this.handleError));
  }

  //Delete changeRequests by Id Delete
  deleteChangeRequests(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/changeRequests/${id}`).pipe(catchError(this.handleError));
  }

   //Update changeRequests by Id Put
   updateChangeRequests(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/changeRequests/${id}`, user).pipe(catchError(this.handleError));
  }

    //Get All changeRequests by Id Get
    getAllchangeRequests(): Observable<Object> {
      return this.http.get(`${environment.apiUrl}/changeRequests`).pipe(catchError(this.handleError));
    }

}
